import React from 'react';
import QuestionInput from './questionInput/QuestionInput';
import QuestionInputNumber from './questionInput/QuestionInputNumber';
import QuestionInputEmail from './questionInput/QuestionInputEmail';
import { IUserInfo, IUserInfoInput } from '../../../../models/UserInfo.interface';
import { useTranslation } from "react-i18next";

const QuestionTable = (props: { userInfo: IUserInfo | undefined; userInfoInput: IUserInfoInput }): JSX.Element => {
    const { t } = useTranslation();

    return (
        <table className="tblarea2">
            <colgroup>
                <col style={{ width: 150 }}></col>
            </colgroup>
            <tbody>
                <tr>
                    <th className="txtlft" scope="row">
                        <div className="inbx">{t("author")}</div>
                    </th>
                    <td>
                        <div className="inbx">
                            {props.userInfo?.name ? (
                                props.userInfo.name
                            ) : (
                                <div className="LUX_basic_text">
                                    <div className="inpbx">
                                        <QuestionInput
                                            placeholder={t("enterName")}
                                            {...props.userInfoInput.name}
                                        />
                                        <span className="sp_lux"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th className="txtlft" scope="row">
                        <div className="inbx">{t("companyName")}</div>
                    </th>
                    <td>
                        <div className="inbx">
                            {props.userInfo?.companyName ? (
                                props.userInfo.companyName
                            ) : (
                                <div className="LUX_basic_text">
                                    <div className="inpbx">
                                        <QuestionInput
                                            placeholder={t("enterCompanyName")}
                                            {...props.userInfoInput.companyName}
                                        />
                                        <span className="sp_lux"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th className="txtlft" scope="row">
                        <div className="inbx">{t("contacts")}</div>
                    </th>
                    <td>
                        <div className="inbx">
                            {props.userInfo?.phone ? (
                                props.userInfo.phone
                            ) : (
                                <div className="LUX_basic_text">
                                    <div className="inpbx">
                                        <QuestionInputNumber
                                            placeholder={t("enterContacts")}
                                            {...props.userInfoInput.phone}
                                        />
                                        <span className="sp_lux"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th className="txtlft" scope="row">
                        <div className="inbx">{t("email")}</div>
                    </th>
                    <td>
                        <div className="inbx">
                            {props.userInfo?.email ? (
                                props.userInfo.email
                            ) : (
                                <div className="LUX_basic_text">
                                    <div className="inpbx">
                                        <QuestionInputEmail
                                            placeholder={t("enterEmail")}
                                            {...props.userInfoInput.email}
                                        />
                                        <span className="sp_lux"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default QuestionTable;
